import { Box, Grid } from '@mui/material'
import React from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import useBookingRecaption from '../../../components/BookingRecaption/hook/useBookingRecaption'
import { useState } from 'react'
import useAxios from '../../../hooks/useAxios'
import BookingRecaption from '../../../components/BookingRecaption/BookingRecaption'
import { routes } from '../../../utils/constants'
import { CloseButton, SaveButton } from '../ClientMmDetails/ClientMmDetails.style'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handelNotifications } from '../../../redux/slices/Notification/notificationSlice'
import TraderHeader from './components/TraderHeader'
import TraderTradingAccounts from './components/TraderTradingAccounts'

const TraderDetails = ({ traderId }) => {
  const [search, setSearch] = useState({ search: '' })
  const token = useSelector(state => state.auth.token)
  const [form, setForm] = useState({
    id: traderId,
    emails: [],
    trader_name: '',
    is_active: false,
    trading_account_names: []
  })
  const [initialForm, setInitialForm] = useState({
    id: traderId,
    emails: [],
    trader_name: '',
    is_active: false,
    trading_account_names: []
  })

  const request1 = {
    endPoint: routes.contractDistribution,
    params: search
  }

  const { response: contractDistribution, setResponse: setResponseContractDistribution } =
    useAxios(request1)

  useEffect(() => {
    const getTrader = async () => {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.trader.concat(`/${traderId}`))
      const trader = await axios.get(url, { headers: { Authorization: token } })
      setForm({
        id: traderId,
        trader_name: trader.data.trader_name,
        emails: trader.data.mailing_list,
        is_active: !!trader.data.is_active,
        trading_account_names: trader.data.trading_account_names
      })
      setInitialForm({
        id: traderId,
        trader_name: trader.data.trader_name,
        emails: trader.data.mailing_list,
        is_active: !!trader.data.is_active,
        trading_account_names: trader.data.trading_account_names
      })
    }
    getTrader()
  }, [traderId])

  const dispatch = useDispatch()
  const { submitNewContract, handelEmail } = useBookingRecaption({
    setSearchEmail: setSearch,
    searchEmail: search,
    form,
    setForm,
    contractDistribution,
    setResponseContractDistribution
  })

  const handelBookingRecaption = event => {
    const { value, checked } = event.target
    const copyForm = JSON.parse(JSON.stringify(form))
    if (checked) {
      copyForm.emails.push(value)
    } else if (!checked) {
      const elementIndex = copyForm.emails.indexOf(value)
      copyForm.emails.splice(elementIndex, 1)
    }
    setForm(copyForm)
  }

  const disable = () => {
    const sameArray = (a, b) => a.length === b.length && a.every(x => b.includes(x))

    const activeTradingAccountNames = data =>
      data.trading_account_names.filter(a => a.is_active).map(a => a.trading_account_name)

    return (
      sameArray(form.emails, initialForm.emails) &&
      form.is_active === initialForm.is_active &&
      sameArray(activeTradingAccountNames(form), activeTradingAccountNames(initialForm))
    )
  }

  const handleDiscardChange = () => {
    setForm(initialForm)
  }

  const handleSubmit = async () => {
    const url = process.env.REACT_APP_SERVER_URL.concat(routes.trader)
    try {
      await axios.put(url, form, { headers: { Authorization: token } })
      setInitialForm(form)
      dispatch(
        handelNotifications({
          id: Date.now(),
          type: 'success',
          message: 'trader update successfully'
        })
      )
    } catch (error) {
      dispatch(
        handelNotifications({
          id: Date.now(),
          type: 'error',
          message: 'sorry something wrong happen'
        })
      )
    }
  }

  const handelChange = (event, elementIndex) => {
    const { name, checked } = event.target
    const copyForm = JSON.parse(JSON.stringify(form))
    if (name === 'is_active') {
      copyForm[name] = checked
    }
    if (name === 'trading_account_names') {
      copyForm[name][elementIndex].is_active = !copyForm[name][elementIndex].is_active
    }
    setForm(copyForm)
  }

  return (
    <>
      <TraderHeader handelChange={handelChange} form={form} />
      <Grid container gap={'40px'}>
        {Array.isArray(contractDistribution.data) && (
          <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column' }}>
            <BookingRecaption
              form={form}
              searchEmail={search}
              handelEmail={handelEmail}
              handelFormChange={handelBookingRecaption}
              contractDistribution={contractDistribution}
              contractDistributionTitle={'Mailing List'}
              submitNewContract={submitNewContract}
              style={{ background: '#242428', maxHeight: '300px', height: '290px' }}
              backgroundSearchBarContainer={'#242428'}
              backgroundSearchBar="#39393C"
              pageArea={'Entity'}
            />
          </Grid>
        )}
        {Array.isArray(form?.trading_account_names) && (
          <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column' }}>
            <TraderTradingAccounts form={form} handelChange={handelChange} />
          </Grid>
        )}
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '12px',
            width: '100%'
          }}
        >
          <CloseButton onClick={handleDiscardChange} disabled={disable()}>
            Discard Changes
          </CloseButton>
          <SaveButton onClick={handleSubmit} disabled={disable()}>
            Save Changes
          </SaveButton>
        </Box>
      </Grid>
    </>
  )
}

export default TraderDetails

TraderDetails.propTypes = { traderId: PropTypes.number }
